export default {
  state: {
    play_position: 0,
    time_clicked: false,
    current_time: '00:00:00'
  },
  mutations: {
    RESET_AUDIO_PLAYER(state) {
      state.play_position = 0
      state.time_clicked = false
      state.current_time = '00:00:00'
    },
    SET_AUDIO_PLAYER_PLAY_POSITION(state, payload) {
      state.play_position = payload
    },
    SET_AUDIO_PLAYER_TIME_CLICKED(state, payload) {
      state.time_clicked = payload
    },
    SET_AUDIO_PLAYER_CURRENT_TIME(state, payload) {
      state.current_time = payload
    }
  }
}
